import React from 'react'

import { buttonStyle } from '../components/commons/buttons/styles/styles.css'
import { ISocialPlatform } from './socials'

export interface IButton {
  variation: keyof typeof buttonStyle
  label?: string
  onClick?: () => void
  children?: React.ReactNode
  navigate?: string
}

export interface IMenuItems {
  logo: boolean
  socials: ISocialPlatform[]
  buttons: IButton[]
}

export interface OptionTab {
  label: string
  value: string
  mobileLabel?: string
  showNotification?: boolean
}

export interface CardInsightData {
  value?: string | number
  label?: string
  state?: string
}

export interface IViewInfoCard {
  avatar: string
  username: string
  date: number
  description: string
}
